import Link from "next/link"

type FixedAddButtonProps = { type: string; openAddExercise?: () => void }

const FixedAddButton = ({ type, openAddExercise }: FixedAddButtonProps) => {
  if (type === "workout") {
    return (
      <div
        style={{ zIndex: "99" }}
        className="fixed bottom-0 flex items-center justify-center md:justify-end p-4 pb-6 md:pb-4 md:px-2 rounded-t-3xl md:rounded-t-none bg-zinc-900 md:bg-transparent w-full max-w-xl md:container pointer-events-none z-100 md:hidden"
      >
        <Link
          href="/workouts/new"
          title="Add a new workout"
          className="bg-pink-600 md:bg-pink-500 hover:bg-pink-600 border-2 border-white font-bold w-full max-w-lg md:max-w-none md:w-20 md:h-20 transition text-lg text-white py-4 rounded-xl text-center group pointer-events-auto shadow-[0_0_0_0_#ffffff] hover:shadow-[0_0_10px_0_#ffffff] active:hover:shadow-[0_0_10px_0_#ffffff]"
        >
          {/* <div className="add-exercise-tooltip absolute top-[31%] -right-[1.1rem] hidden md:block bg-zinc-800 border-2 border-white text-white opacity-0 group-hover:opacity-100 text-sm p-3 rounded-xl -translate-y-20 group-hover:-translate-y-24 transition">
            Add a workout
          </div> */}
          {/* <span className="md:block hidden text-2xl translate-y-[7px]">+</span> */}
          <span className="inline md:hidden">+ Add a workout</span>
        </Link>
      </div>
    )
  }

  if (type === "exercise") {
    return (
      <div className="fixed bottom-0 flex items-center justify-center md:justify-end p-4 pb-6 md:pb-4 md:px-2 rounded-t-3xl md:rounded-t-none bg-zinc-900 md:bg-transparent  w-full max-w-xl md:hidden pointer-events-none">
        <button
          aria-label="Add an exercise"
          onClick={openAddExercise}
          className="bg-pink-600 md:bg-pink-500 hover:bg-pink-600 border-2 border-white font-bold w-full max-w-lg md:max-w-none md:w-20 md:h-20 transition text-lg text-white py-4 rounded-xl text-center group pointer-events-auto shadow-[0_0_0_0_#ffffff] hover:shadow-[0_0_10px_0_#ffffff] active:hover:shadow-[0_0_10px_0_#ffffff]"
        >
          <span className="inline md:hidden">+ Add an exercise</span>
        </button>
      </div>
    )
  }
}

export default FixedAddButton
